import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { PpbSharedModule } from '../../../../projects/ppb-shared-library/src/lib/ppb-shared.module';
import { PseiNgCustomModule } from '../../../../projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { PpbShareModule } from '../shared/ppb-share.module';
import { PpbLoginComponent } from './ppb-login.component';


@NgModule({
  declarations: [PpbLoginComponent],
  imports: [
    CommonModule,
    PpbSharedModule,
    SharedModule,
    PseiNgCustomModule,
    RouterModule,
    ReactiveFormsModule,
    PpbShareModule,
  ]
})
export class PpbLoginModule {}
